import { useCallback } from 'react';
import { type EventSourceMessage } from '@microsoft/fetch-event-source';
import { useMercureSubscription } from './useMercureSubscription';
import { MERCURE_TOPICS } from '@/constants/mercureTopics';
import { parseSocketOrderEvent } from '@/utils/parseSocketOrderEvent';
import { type ISocketOrderEvent } from '@/types/ISocketOrderEvent';

interface IUseMercureOrdersParams {
  onOrderEvent: (event: ISocketOrderEvent) => void;
  enabled: boolean;
}

/**
 * Хук подписки на события заказов из Mercure.
 * Поверх базового useMercureSubscription парсит сырое сообщение в
 * ISocketOrderEvent и отдаёт валидное событие наверх. Бизнес-логику
 * (упорядочивание, вставку в стор) не содержит — остаётся «тупым».
 *
 * @param params.onOrderEvent - обработчик распарсенного события заказа
 * @param params.enabled - запускать подписку только когда `true`
 */
export const useMercureOrders = ({
  onOrderEvent,
  enabled
}: IUseMercureOrdersParams): void => {
  const handleMessage = useCallback(
    (message: EventSourceMessage) => {
      const orderEvent = parseSocketOrderEvent(message.data);

      if (orderEvent === null) {
        return;
      }

      onOrderEvent(orderEvent);
    },
    [onOrderEvent]
  );

  useMercureSubscription({
    topics: MERCURE_TOPICS,
    onMessage: handleMessage,
    enabled
  });
};
